import { useState, useEffect } from 'react';
import { AppButton } from 'components';
import * as AppPics from 'assets/images';

function ManageSprint({ sprint, index, handleDelete, onEdit, isEditing }) {
  console.log('🚀 ~ ManageSprint ~ sprint:', sprint);
  // const [editMode, setEditMode] = useState(false);
  const [title, setTitle] = useState('');

  useEffect(() => {
    setTitle(sprint.title || '');
  }, [sprint.title]);

  return (
    <div className="d-flex justify-content-between align-items-center w-100">
      {/* TITLE AREA */}
      <div className="flex-grow-1 mx-4">
        <h5 className="mb-1">{sprint?.title ? sprint.title : `Sprint ${index + 1}`}</h5>

        {/* {editMode && (
          <input
            type="text"
            value={title}
            className="form-control"
            onChange={(e) => setTitle(e.target.value)}
          />
        )} */}

        <small className="contentTypeText">
          {sprint?.contentType && sprint.contentType === 'text' ? 'Text' : 'Equation'}
        </small>
      </div>

      {/* ACTION BUTTONS */}
      <div className="d-flex gap-2">
        {isEditing && (
          <span className="ms-2 badge bg-warning text-dark editing-badge">Editing</span>
        )}
        {!isEditing && (
          <AppButton variantClass="lessonWrap__btn" onClick={() => onEdit(sprint)} title="Edit">
            <img src={AppPics.EditSvg} alt="" />
          </AppButton>
        )}
        <AppButton
          variantClass="lessonWrap__btn"
          onClick={() => handleDelete(sprint)}
          title="Delete"
        >
          <img src={AppPics.TrashBinSvg} alt="" />
        </AppButton>
      </div>
    </div>
  );
}

export default ManageSprint;
